import React from 'react'
import heroimg from '../../assets/hero-bg3.png'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import {  FaLinkedinIn , FaFacebookF ,FaInstagram  } from 'react-icons/fa6'
import { Typewriter } from "react-simple-typewriter";
import { FaArrowRightLong } from "react-icons/fa6";

const Hero = () => {
  return (
    <div className='max-w-[1400px] 2xl:mx-auto mx-4 md:mt-[50px]'>
      <div className="flex md:flex-row md:gap-0 gap-9 flex-col justify-between">
      <div className='flex-1 md:mt-24 mt-6'>
            <span className='bg-[#0788ff33] uppercase md:text-2xl px-3 rounded-lg py-1'>
                Hi I'm,
            </span>
            <h1 className="md:text-5xl text-2xl font-semibold uppercase md:mt-4 mt-2">
                Muhammad Abu Bakar
            </h1>
            <h1 className='md:text-5xl text-2xl font-bold text-secondary uppercase md:mt-4'>I am a 
                <Typewriter
                    words={[' Web Designer',' Web Developer']}
                    loop={false} // Set true for infinite loop
                    cursor
                    cursorStyle='_'
                    typeSpeed={70} // Speed of typing
                    deleteSpeed={50} // Speed of deleting
                    delaySpeed={1000} // Delay before retyping
                />
            </h1>
            <p className='text-light md:mr-44 md:mt-6 mt-3'>As a skilled Web Developer and Designer, I specialize in creating responsive, user-friendly websites with a
focus on modern design and efficient code. </p>
            <div className='flex md:flex-row flex-col items-center mt-9 gap-6'>
                <div>
                    <HashLink to='#contact' smooth className='flex  items-center gap-2 bg-secondary border-2 border-secondary hover:border-white hover:bg-dark duration-300 shadow-lg shadow-secondary/50 rounded-full uppercase font-medium py-3 px-9'>Get in Touch <FaArrowRightLong/>  </HashLink>
                </div>
                <div className="flex items-center gap-4">
                    <Link target='_blank' to='https://www.facebook.com/m.abubakaransari6' className='bg-blue-500 border-2 border-white hover:-translate-y-2 duration-300 shadow-lg active:-translate-y-0 hover:shadow-secondary p-4 rounded-full text-2xl'><FaFacebookF/></Link>
                    <Link target='_blank' to='https://www.instagram.com/abubakaransari3932/' className='bg-pink-600 border-2 border-white hover:-translate-y-2 duration-300 shadow-lg active:-translate-y-0 hover:shadow-secondary p-4 rounded-full text-2xl'><FaInstagram/></Link>
                    <Link target='_blank' to='https://www.linkedin.com/in/muhammad-abu-bakar-982007338/' className='bg-sky-400 border-2 border-white hover:-translate-y-2 duration-300 shadow-lg active:-translate-y-0 hover:shadow-secondary p-4 rounded-full text-2xl'><FaLinkedinIn/></Link>
                </div>
            </div>
                <h4 className='md:text-left text-center font-medium md:mt-16 mt-8'>Do You a Project? <HashLink to='#contact' smooth className='text-secondary underline'>Let's Talk</HashLink></h4>
        </div>
        <div className="">
            <img className='w-[620px] ' src={heroimg} alt="" loading='lazy'/>
        </div>
      </div>
    </div>
  )
}

export default Hero
